const MRSManager = [
  {
    title: 'Dashboard',
    is_heading: false,
    is_active: false,
    link: {
      name: 'rsm.dashboard'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-objects-column',
    active_icon: 'fad fa-objects-column'
  },
  {
    title: 'Customer Memos',
    is_heading: false,
    is_active: false,
    link: {
      name: 'rsm.memos'
    },
    class_name: '',
    collapsable: false,
    is_icon_class: true,
    icon: 'fat fa-file-pdf',
    active_icon: 'fad fa-file-pdf',
    children: [
      {
        link: {
          name: 'rsm.memos.signed-memos'
        }
      }
    ]
  },
  {
    title: 'Accounts',
    is_heading: true,
    is_active: false,
    link: {
      name: 'asm.accounts'
    },
    class_name: 'mt-3 font-weight-bolder'
  },
  {
    title: 'Customers',
    is_heading: false,
    is_active: false,
    link: {
      name: 'rsm.customers'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-user-tie-hair',
    active_icon: 'fad fa-user-tie-hair',
    children: [
      {
        link: {
          name: 'rsm.customers.profile'
        }
      }
    ]
  },
  {
    title: 'ASM\'s',
    is_heading: false,
    is_active: false,
    link: {
      name: 'rsm.area-managers'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-user-tie-hair',
    active_icon: 'fad fa-user-tie-hair'
  }
]

const MRSManagerAreaManagerTracking = [
  {
    title: 'ASM Tracking',
    is_heading: true,
    is_active: false,
    link: {
      name: 'rsm.area-managers.other-events'
    },
    class_name: 'mt-3 font-weight-bolder'
  },
  {
    title: 'Other Activities',
    is_heading: false,
    is_active: false,
    link: {
      name: 'rsm.area-managers.other-events'
    },
    class_name: '',
    collapsable: false,
    is_icon_class: true,
    icon: 'fat fa-list-tree',
    active_icon: 'fad fa-list-tree',
    children: [
      {
        link: {
          name: 'rsm.area-managers.other-events.reports'
        }
      }
    ]
  }
  // {
  //   title: 'Monthly Plans',
  //   is_heading: false,
  //   is_active: false,
  //   link: {
  //     name: 'rsm.area-managers.monthly-plans'
  //   },
  //   class_name: '',
  //   collapsable: false,
  //   is_icon_class: true,
  //   icon: 'fat fa-calendar-lines',
  //   active_icon: 'fad fa-calendar-lines'
  // }
]

const MRSManagerOfficerTracking = [
  {
    title: 'FSO Tracking',
    is_heading: true,
    is_active: false,
    link: {
      name: 'rsm.officers'
    },
    class_name: 'mt-3 font-weight-bolder'
  },
  // {
  //   title: 'Monthly Plans',
  //   is_heading: false,
  //   is_active: false,
  //   link: {
  //     name: 'rsm.officers.monthly-plans'
  //   },
  //   class_name: '',
  //   collapsable: false,
  //   is_icon_class: true,
  //   icon: 'fat fa-calendar-lines',
  //   active_icon: 'fad fa-calendar-lines'
  // },
  // {
  //   title: 'Task Events',
  //   is_heading: false,
  //   is_active: false,
  //   link: {
  //     name: 'rsm.officers.events'
  //   },
  //   class_name: '',
  //   is_icon_class: true,
  //   icon: 'fat fa-diagram-subtask',
  //   active_icon: 'fad fa-diagram-subtask'
  // }
  {
    title: 'Other Activities',
    is_heading: false,
    is_active: false,
    link: {
      name: 'rsm.officers.other-events'
    },
    class_name: '',
    collapsable: false,
    is_icon_class: true,
    icon: 'fat fa-list-tree',
    active_icon: 'fad fa-list-tree'
  }
]

export default MRSManager.concat(
  MRSManagerAreaManagerTracking,
  MRSManagerOfficerTracking
)
